"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AlertIcon = _ref => {
  let {
    icon: Icon
  } = _ref;
  if (Icon) {
    return /*#__PURE__*/_react.default.createElement(Icon, null);
  }
  return null;
};
var _default = exports.default = AlertIcon;